/**
 * STOP. READ THIS BEFORE ADDING ANYTHING.
 *
 * This hook is a THIN convenience wrapper. Nothing more.
 * - NO state management
 * - NO loading states
 * - NO error handling
 * - NO caching
 * - NO side effects
 *
 * If you need any of that, use gameApi directly or create a
 * separate hook for your specific use case.
 *
 * This hook will be deleted if it grows beyond 20 lines.
 */
import { gameApi } from "@/api/utils";
import { useAuth } from "@/context/AuthContext";
import { Constants, type AtomicMove } from "@nextgammon/shared";
import { useMemo } from "react";

export function useGameApi() {
  const { token } = useAuth();

  return useMemo(() => {
    if (!token) {
      return null;
    }

    return {
      getGame: (gameId: string) => gameApi.getGame(token, gameId),
      rollDice: (gameId: string) => gameApi.rollDice(token, gameId),
      submitTurn: (gameId: string, moves: AtomicMove[]) => gameApi.submitTurn(token, gameId, moves),
      joinGame: (gameId: string) => gameApi.joinGame(token, gameId),
      offerDouble: (gameId: string) => gameApi.offerDouble(token, gameId),
      respondToDouble: (gameId: string, accept: boolean) =>
        gameApi.respondToDouble(token, gameId, accept),
      sendEmote: (gameId: string, emoteId: Constants.EmoteId) =>
        gameApi.sendEmote(token, gameId, emoteId),
      resign: (gameId: string) => gameApi.resign(token, gameId)
    };
  }, [token]);
}
